export default __webpack_public_path__ + "static/media/foto-diferencial-mobile.80396342.png";